import { type FunctionComponent } from 'react';
import { SvgIcon, type SvgIconProps } from './SvgIcon';

export const EmojiIcon: FunctionComponent<SvgIconProps> = (props) => {
  return (
    <SvgIcon height="20" viewBox="0 0 20 20" width="20" {...props}>
      <path
        d="M13.5 8.99976C14.3284 8.99976 15 8.32818 15 7.49976C15 6.67133 14.3284 5.99976 13.5 5.99976C12.6716 5.99976 12 6.67133 12 7.49976C12 8.32818 12.6716 8.99976 13.5 8.99976Z"
        fill="currentcolor"
      />
      <path
        d="M6.5 8.99976C7.32843 8.99976 8 8.32818 8 7.49976C8 6.67133 7.32843 5.99976 6.5 5.99976C5.67157 5.99976 5 6.67133 5 7.49976C5 8.32818 5.67157 8.99976 6.5 8.99976Z"
        fill="currentcolor"
      />
      <path
        d="M10 16C12.28 16 14.22 14.34 15 12H5C5.78 14.34 7.72 16 10 16Z"
        fill="currentcolor"
      />
      <path
        d="M9.99 0C4.47 0 0 4.48 0 10C0 15.52 4.47 20 9.99 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 9.99 0ZM10 18C5.58 18 2 14.42 2 10C2 5.58 5.58 2 10 2C14.42 2 18 5.58 18 10C18 14.42 14.42 18 10 18Z"
        fill="currentcolor"
      />
    </SvgIcon>
  );
};
